// extracted by mini-css-extract-plugin
export default {"links":"sidebar_links__hlZEk"};